import { Unsubscribe } from "@firebase/util";
import { makeAutoObservable } from "mobx";
import { compareStrings } from "utils";
import { DashboardStore, KanbanStore } from "../";
import ContractModel from "../../api/models/ContractModel";
import ContractService from "../../api/services/ContractService";

class Store {
  private _contractsListener: Unsubscribe | undefined = undefined;
  public contracts: ContractModel[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  private reset() {
    this._contractsListener = undefined;
    this.contracts = [];
  }

  subscribeContractListObserver(): void {
    this.unscribeContracts();
    this._contractsListener = ContractService.subscribeContractsSnapshot(
      (contractsAdded) => {
        this.addContractsToList(contractsAdded);
        KanbanStore.refreshFilteredContracts();
        DashboardStore.refreshContractsData();
      },
      (contractsChanged) => {
        this.changeContractsOnList(contractsChanged);
        KanbanStore.refreshFilteredContracts();
        DashboardStore.refreshContractsData();
      },
      (contractsRemoved) => {
        this.removeContractsFromList(contractsRemoved);
        KanbanStore.refreshFilteredContracts();
        DashboardStore.refreshContractsData();
      }
    );
  }

  private addContractsToList(contractsAdded: ContractModel[]) {
    this.contracts = this.contracts
      .concat(contractsAdded)
      .sort((a, b) => compareStrings(a.name, b.name));
  }

  private changeContractsOnList(contractsChanged: ContractModel[]) {
    const contracts = [...this.contracts];
    contractsChanged.forEach((contract) => {
      const index = contracts.findIndex((c) => c.uid === contract.uid);
      if (index !== -1) contracts[index] = contract;
    });
    this.contracts = contracts.sort((a, b) => compareStrings(a.name, b.name));
  }

  private removeContractsFromList(contractsRemoved: ContractModel[]) {
    const uids = contractsRemoved.map((contract) => contract.uid);
    this.contracts = this.contracts.filter((cntr) => !uids.includes(cntr.uid));
  }

  unscribeContracts(): void {
    if (this._contractsListener) {
      this._contractsListener();
    }
    this.reset();
  }

  /** Procura na lista de contratos em memória, o contrato com o ID
   * informado.
   */
  findContract(uid: string): ContractModel | undefined {
    return this.contracts.find((contract) => contract.uid === uid);
  }
}

const ContractListStore = new Store();
export default ContractListStore;
